import { useRouter } from "next/router";
import { useEffect } from "react";
import styled, { keyframes } from "styled-components";

const LoaderWrapper = styled.div`
  display: flex;
  height: 100%;
  width: 100%;
`;

const loadingAnimation = keyframes`
  0% {
    background-color: #fff;
  }
  50% {
    background-color: #efefef;
  }
  100% {
    background-color: #fff;
  }
`;

const TemplateLoaderContainer = styled.div`
  display: flex;
  width: 100px;
  svg {
    width: 100px;
    height: 100px;
    margin: 20px;
    display: inline-block;
  }
`;

const SkeletonContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  animation: ${loadingAnimation} 1s infinite;
`;

const SkeletonHeroBlock = styled.div`
  width: 100%;
  height: 250px;
  margin-bottom: 10px;
  background-color: #efefef;
  display: flex;
  justify-content: space-around;
  align-items: center;
  div {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: space-around;
    div {
      width: 80%;
      height: 10px;
      background-color: #e2e0e0;
      border-radius: 10px;
      margin: 10px;
      /* animation: ${loadingAnimation} 1s infinite; */
    }
    div:nth-child(2) {
      width: 60%;
    }
    div:nth-child(4) {
      width: 40%;
    }
  }
`;

const SkeletonContentBlock = styled(SkeletonHeroBlock)`
  div {
    width: 25%;
    height: 150px;
    background-color: #e2e0e0;
    border-radius: 10px;
  }
`;

function PageLoader() {
  return (
    <LoaderWrapper>
      <SkeletonContainer>
        <SkeletonHeroBlock>
          <div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </SkeletonHeroBlock>
        <SkeletonContentBlock>
          <div></div>
          <div></div>
          <div></div>
        </SkeletonContentBlock>
        <SkeletonContentBlock>
          <div></div>
          <div></div>
          <div></div>
        </SkeletonContentBlock>
      </SkeletonContainer>
    </LoaderWrapper>
  );
}

function TemplateLoader() {
  return (
    <TemplateLoaderContainer>
      <svg
        version="1.1"
        id="L5"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 100 100"
        enableBackground="new 0 0 0 0"
      >
        <circle fill="#F86A6E" stroke="none" cx="6" cy="50" r="6">
          <animateTransform
            attributeName="transform"
            dur="1s"
            type="translate"
            values="0 15 ; 0 -15; 0 15"
            repeatCount="indefinite"
            begin="0.1"
          />
        </circle>
        <circle fill="#F86A6E" stroke="none" cx="30" cy="50" r="6">
          <animateTransform
            attributeName="transform"
            dur="1s"
            type="translate"
            values="0 10 ; 0 -10; 0 10"
            repeatCount="indefinite"
            begin="0.2"
          />
        </circle>
        <circle fill="#F86A6E" stroke="none" cx="54" cy="50" r="6">
          <animateTransform
            attributeName="transform"
            dur="1s"
            type="translate"
            values="0 5 ; 0 -5; 0 5"
            repeatCount="indefinite"
            begin="0.3"
          />
        </circle>
      </svg>
    </TemplateLoaderContainer>
  );
}

function ContentLoader() {
  return (
    <SkeletonContentBlock>
      <div></div>
      <div></div>
      <div></div>
    </SkeletonContentBlock>
  );
}

export { PageLoader, TemplateLoader, ContentLoader };
